export default {
  itemSelect: 'grid-item-select',
  itemDelete: 'grid-item-delete',
  itemErase: 'grid-item-erase',
  item: 'grid-item',
};
